import $ from "jquery";
import { isMobile } from './components/isMobile';
import LazyLoadInnit from './components/LazyLoad';
import Popup from './components/Popup';
import Gallery from './components/Gallery';
import Nav from './components/Nav';
import Tab from '../../node_modules/bootstrap/js/dist/tab';

global.jQuery = global.$ = $;

$(() => {
    require('./../../node_modules/popper.js/dist/popper.min.js');
});